import { render, staticRenderFns } from "./card-brand.vue?vue&type=template&id=315f1105"
import script from "./card-brand.vue?vue&type=script&lang=ts"
export * from "./card-brand.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315f1105')) {
      api.createRecord('315f1105', component.options)
    } else {
      api.reload('315f1105', component.options)
    }
    module.hot.accept("./card-brand.vue?vue&type=template&id=315f1105", function () {
      api.rerender('315f1105', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/card-brand.vue"
export default component.exports